import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// Type definitions for the breadcrumb item and final item
interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface CommonBreadcrumbsProps {
  items: BreadcrumbItem[];
  final?: BreadcrumbItem;
}

const CommonBreadcrumbs: React.FC<CommonBreadcrumbsProps> = ({ items, final }) => {
  return (
    <Breadcrumbs
      sx={{
        mb: 1,
        mt:{xs:2,sm:3,md:0},
        '& .MuiBreadcrumbs-separator:nth-of-type(2) .customIcon': {
          color: '#FF5C39',
        },
      }}
      aria-label="breadcrumb"
      separator={
        <NavigateNextIcon
          className="customIcon"
          sx={{
            color: '#C5C9CD',
          }}
        />
      }
    >
      {items.map((item, index) => {
        if (item.href) {
          return (
            <Link
              key={index}
              underline="hover"
              href={item.href}
              sx={{ fontSize: 14 }}
              onClick={item.onClick}
            >
              {item.label}
            </Link>
          );
        }
        return (
          <Typography
            key={index}
            sx={{
              cursor: 'pointer',
              color: '#FF5C39',
              '&:hover': {
                color: '#FF5C39',
              },
            }}
            onClick={item.onClick}
            fontSize={14}
            fontWeight={500}
            color="textPrimary"
          >
            {item.label}
          </Typography>
        );
      })}
      {final && (
        <Typography
          sx={{
            fontSize: 14,
            // cursor: 'pointer',
            color: '#C5C9CD',
            // '&:hover': {
            //   color: '#FF5C39',
            // },
          }}
          fontWeight={500}
          // onClick={final?.onClick}
          color="textPrimary"
        >
          {final.label}
        </Typography>
      )}
    </Breadcrumbs>
  );
};

export default CommonBreadcrumbs;
